import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { DevErrorProvider } from './lib/dev-errors';
import './app/globals.css';
import './styles/table-fix.css';
import './styles/map-fullscreen.css';
import './styles/time-inputs.css';
import 'mapbox-gl/dist/mapbox-gl.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      {import.meta.env.DEV ? (
        <DevErrorProvider>
          <App />
        </DevErrorProvider>
      ) : (
        <App />
      )}
    </ErrorBoundary>
  </React.StrictMode>
);
